/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-undef */
/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import ThreeDotsLoader from '../../../Components/LoadingDots';

export default function RemovePopup({
    removeParams, setModalType, DistributorData, handleUpdate, loading, setloading,
}) {
    const handleRemove = () => {
        const DistributorCopy = { ...DistributorData };
        const supportCopy = [...DistributorCopy.SUPPORTS];
        const data = DistributorCopy.SUPPORTS.map((val) => val.EMAIL).indexOf(removeParams.item.EMAIL);
        if (data > -1) {
            DistributorCopy.SUPPORTS.splice(data, 1);
            handleUpdate(DistributorCopy);
        }
    };
    return (

        <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none max-w-[441px]">
            <div
                className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
            >
                <div className="modal-dialog modal-dialog-centered relative pointer-events-none max-w-[448px]">
                    <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                        <div className="modal-header flex flex-shrink-0 items-center justify-between p-4 rounded-t-md">
                            <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel">
                                Remove
                                {' '}
                                {removeParams.type}
                                {' '}

                                <>
                                    {`(${removeParams.shortcut}
                                    )`}
                                </>

                            </h5>
                            <button
                                type="button"
                                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body relative px-9 pt-2 pb-6 text-center">
                            <p className="text-xs6 font-normal text-[#555259]">
                                Are you sure you want to remove this
                                {' '}
                                {removeParams.shortcut}
                                ?
                            </p>
                        </div>
                        <div className="modal-footer flex pb-6 rounded-b-md px-9">
                            <button
                                onClick={() => setModalType('')}
                                type="button"
                                className="border border-[#555259] bg-[#ffffff] text-base font-normal text-[#555259] py-3 w-[168px] rounded-lg mr-[22px]"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                Cancel
                            </button>
                            <button onClick={() => handleRemove()} type="button" className="border border-[#673593] bg-[#555259] text-base font-normal text-[#ffffff] py-3 w-[168px] rounded-lg remove-bh flex justify-center items-center" data-bs-dismiss="modal" aria-label="Close">
                                {loading ? <ThreeDotsLoader /> : ' Yes, remove'}
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
